import { Breadcrumb } from "@kazaar-platform/design-system";
import { Fragment } from "react";
import { useMatches } from "react-router-dom";
import {
  type BreadcrumbHandle,
  type BreadcrumbMatch,
} from "./ConnectedBreadcrumb.types";

export const ConnectedBreadcrumb = () => {
  const matches = useMatches();

  const items = matches.filter((match): match is BreadcrumbMatch => {
    return (
      match.handle !== null &&
      typeof match.handle === "object" &&
      "crumb" in match.handle &&
      typeof (match.handle as BreadcrumbHandle).crumb === "function"
    );
  });

  return (
    <Breadcrumb>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <Fragment key={item.id}>
            <Breadcrumb.Item
              id={item.id}
              href={isLast ? undefined : item.pathname}
            >
              {item.handle.crumb(item.data)}
            </Breadcrumb.Item>

            {!isLast && <Breadcrumb.Separator />}
          </Fragment>
        );
      })}
    </Breadcrumb>
  );
};
